'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = guid;

var _nodeUuid = require('node-uuid');

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function guid() {
  return _nodeUuid2.default.v4();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Guid.js
// module id = 275
// module chunks = 0